// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"765e9941","239":"f87682dd","453":"a0ff73a3","455":"66b7e446"}[chunkId] + ".chunk.js";
};